import { Component, OnDestroy, OnInit } from '@angular/core';
import { ThemeService } from './core/services/theme.service';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { NgClass } from '@angular/common';
import { ResponsiveHelperComponent } from './shared/components/responsive-helper/responsive-helper.component';
import { initFlowbite } from 'flowbite';
import { filter, Subscription } from 'rxjs';
import { IdleService } from './services/idle.service';
import { IdleWarningComponent } from './shared/components/idle-warning/idle-warning.component';
import { getLoggedInUser } from './shared/security/cookies';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [NgClass, RouterOutlet, ResponsiveHelperComponent, IdleWarningComponent],
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'Merchant Portal';

  private subscription = new Subscription();
  constructor(
    private router: Router,
    private idleService: IdleService,
    public themeService: ThemeService,
  ) {
    initFlowbite();
  }

  ngOnInit() {
    // Start idle monitoring when user is authenticated
    this.subscription.add(
      this.router.events
        .pipe(filter((event: any) => event instanceof NavigationEnd))
        .subscribe((event: NavigationEnd) => {
          // Check if user is on a protected route (not login/register)
          const protectedRoutes = ['/dashboard/merchant', '/profile', '/settings']; // Add your protected routes
          const isProtectedRoute = protectedRoutes.some((route) => event.urlAfterRedirects.startsWith(route));

          if (isProtectedRoute && this.isUserAuthenticated()) {
            this.idleService.startWatching();
            console.log('Started Watching');
          } else {
            this.idleService.stopWatching();
            console.log('Stopped Watching');
          }
        }),
    );

    // Listen for idle state
    this.subscription.add(
      this.idleService.isIdle.subscribe((isIdle) => {
        if (isIdle) {
          console.log('User has been logged out due to inactivity');
        }
      }),
    );
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
    this.idleService.stopWatching();
  }

  private isUserAuthenticated(): boolean {
    // Replace with your actual authentication check
    return getLoggedInUser().token;
  }
}
